import * as types from "../types";

const initialState = {
    data: {
        docs: [],
        page: 1,
        pages: 1,
        limit: 10,
        total: 0
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_ALL_NOTIFYS:
            return { ...state, data: action.payload };

        case types.GET_NOTIFY:
            return { ...state, unique: action.payload };

        default:
            return { ...state };
    }
};

export default reducer;
